<div [ngStyle]="contentStyle" *ngIf="isWorkflow" class="selfie-page" style="height: 100%; overflow-y: auto">
  <div class="title">
    <h1>SELFIE</h1>
  </div>

  <div class="sub-title">
    <p>
      Face the camera . Ensure your face is within the frame. Then , slowly turn your head around in a circle.
    </p>
  </div>

  <div class="vedio">
    <video
      autoplay="autoplay"
      muted="muted"
      playsinline=""
      loop="loop"
      width="250"
      height="250"
      class="tutorial-video"
    >
      <source
        title="vxvxc"
        src="assets/idensic/media/liveness-tutorial.fa713ef0.webm"
        type="video/webm; codecs='vp8, vorbis'"
      />
      <source title="vxvxc" src="assets/idensic/media/liveness-tutorial.0b3f1b93.mp4" type="video/mp4" />
    </video>
  </div>
  <div class="ready-btn">
    <finx-button class="submit-button-proceed btn w-100 mt-2" labeltext="I`M READY "></finx-button>
  </div>
  <div class="continue-link">
    <a>or continue on phone</a>
  </div>

  <div class="sumsub-logo">
    <img alt="sumsub-logo" src="assets/images/sumsub-logo.png" />
  </div>
</div>

<app-kyc-provider
  *ngIf="!isWorkflow"
  [contentConfigStyle]="contentStyle"
  [applicationCompleteMessage]="applicationCompleteMessage"
></app-kyc-provider>
